export default {
  catalogue: "catalogue".toUpperCase(),
  blog: "blog".toUpperCase(),
  faq: "f.a.q".toUpperCase(),
  about_fraudvision: "about fraudvision".toUpperCase(),
  contact_us: "contact us".toUpperCase(),

  thats_the_vision: "thats the vision".toUpperCase(),
};
